import { render, staticRenderFns } from "./dataHistory.vue?vue&type=template&id=6575a81c&scoped=true&"
import script from "./dataHistory.vue?vue&type=script&lang=js&"
export * from "./dataHistory.vue?vue&type=script&lang=js&"
import style0 from "./dataHistory.vue?vue&type=style&index=0&id=6575a81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6575a81c",
  null
  
)

export default component.exports